import { render, staticRenderFns } from "./IconLogout.vue?vue&type=template&id=513fd974&scoped=true&functional=true&"
import script from "./IconLogout.vue?vue&type=script&lang=js&"
export * from "./IconLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "513fd974",
  null
  
)

export default component.exports